import axios from "axios";
import useSWR from "./useSWR";
import { fetchClinicalEligibility } from "./assessment";
import { logger } from "./logger";

const ppmService = axios.create({
  baseURL: window.ww.wwAPI,
  timeout: 5000
});

/**
 *
 * @param {string[]} param0
 * @returns
 */
export async function fetchBundle([, id]) {
  const url = `/ppm/v1/offers/bundles/${id}`;
  return await ppmService.get(url);
}

/**
 *
 * @param {string[]} param0
 * @returns
 */
export async function fetchPlan([, id, locale, isSequence]) {
  // Check eligibility endpoint for alternate offer plans.
  // Alternate offer plans can be returned if the user is lapsed.
  // Only use alternate offer plan if the user is sequence eligible.
  let planId = id;
  if (isSequence) {
    try {
      const memberData = await fetchClinicalEligibility([null, locale]);
      planId =
        memberData?.data?.isEligible && memberData?.data?.eligibilityOfferPlanId
          ? memberData?.data?.eligibilityOfferPlanId
          : planId;
    } catch (error) {
      // Log users whose sesssion has expired as a warning.
      const level = error?.response?.status === 401 ? "warn" : "error";
      logger("Error fetching clinical eligibility offer plan", {
        level,
        customAttributes: { error }
      });
    }
  }

  const url = `/ppm/v1/offers/plans/${planId}?locale=${locale}`;
  return await ppmService.get(url);
}

export function fetchPlans([key, ids, locale, isSequence]) {
  return Promise.all(
    ids.map(id => {
      return fetchPlan([key, id, locale, isSequence]);
    })
  );
}

/**
 *
 * @param {string} id
 * @returns
 */

export function useFetchBundle(id) {
  return useSWR(id ? ["bundle", id] : null, fetchBundle);
}

/**
 *
 * @param {string} id
 * @param {string} locale
 * @returns
 */
export function useFetchPlan(id, locale) {
  return useSWR(id ? ["plan", id, locale] : null, fetchPlan);
}

/**
 *
 * @param {string[]} ids
 * @param {*string} locale
 * @returns
 */
export function useFetchPlans(ids = [], locale, isSequence = false) {
  return useSWR(
    ids.length ? ["plans", ids, locale, isSequence] : null,
    fetchPlans
  );
}
